import Skeleton from "react-loading-skeleton";

const SkeletonCategory = ({ type = "button" }) => {
  if (type === "select") {
    // Skeleton داخل الـ select dropdown
    return (
      <li className="select-item">
        <Skeleton width={80} height={20} borderRadius={6} />
      </li>
    );
  }

  // Skeleton داخل قائمة الأزرار
  return (
    <li className="filter-item">
      <Skeleton width={70} height={28} borderRadius={20} />
    </li>
  );
};

export default SkeletonCategory;
